"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("reactstrap/lib/Input"));

var _CustomInput = _interopRequireDefault(require("reactstrap/lib/CustomInput"));

var _get = _interopRequireDefault(require("lodash/get"));

var _utils = require("./utils");

var _icon = _interopRequireDefault(require("../icon/icon"));

var _inputFeedback = _interopRequireDefault(require("../inputFeedback/inputFeedback"));

var _toggleButton = _interopRequireDefault(require("../toggleButton/toggleButton"));

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _icons = require("./icons");

var _excluded = ["block"],
    _excluded2 = ["isInvalid", "validationProps", "disableInputFeedback"],
    _excluded3 = ["showClearIcon", "clearTooltipText", "onSearch", "onClear", "clickable", "dataTestId"],
    _excluded4 = ["isInvalid", "options", "validationProps", "disableInputFeedback"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var InputUtils = /*#__PURE__*/(0, _createClass2["default"])(function InputUtils() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, InputUtils);
  (0, _defineProperty2["default"])(this, "blockProp", false);
  (0, _defineProperty2["default"])(this, "isInvalidId", function (id) {
    return typeof id === "undefined" || id === null || id === "";
  });
  (0, _defineProperty2["default"])(this, "getCustomInputProps", function (props) {
    var type = props.type,
        id = props.id;

    if (_this.isInvalidId(id)) {
      return _objectSpread(_objectSpread({}, props), {}, {
        id: (0, _utils.generateId)("".concat(type, "-control-"))
      });
    }

    return props;
  });
  (0, _defineProperty2["default"])(this, "renderInputComponent", function (props) {
    var _context;

    var block = props.block,
        attr = (0, _objectWithoutProperties2["default"])(props, _excluded);
    _this.blockProp = block;

    if ((0, _indexOf["default"])(_context = ["checkbox", "radio", "switch", "select", "file", "range"]).call(_context, attr.type) === -1) {
      return _this.renderInput(attr);
    }

    var customInputProps = _this.getCustomInputProps(attr);

    return _this.renderCustomInput(customInputProps);
  });
  (0, _defineProperty2["default"])(this, "renderInput", function (props) {
    var isInvalid = props.isInvalid,
        validationProps = props.validationProps,
        disableInputFeedback = props.disableInputFeedback,
        attr = (0, _objectWithoutProperties2["default"])(props, _excluded2);

    if (attr.type === "button" || attr.type === "reset" || attr.type === "submit") {
      return _this.renderInputButton(attr);
    }

    if (attr.type === "search") {
      return _this.renderInputSearch(attr);
    }

    if (attr.type === "toggle") {
      return _this.renderToggleInput(props);
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
      "data-testid": attr.dataTestId || "orion-".concat(attr.type, "-input")
    }, attr, {
      onChange: validationProps && (0, _utils.isFunction)(validationProps.handleChange) ? function (event) {
        validationProps.handleChange(event);

        if ((0, _utils.isFunction)(attr.onChange)) {
          attr.onChange(event);
        }
      } : attr.onChange,
      onBlur: validationProps && (0, _utils.isFunction)(validationProps.handleBlur) ? function (event) {
        validationProps.handleBlur(event);

        if ((0, _utils.isFunction)(attr.onBlur)) {
          attr.onBlur(event);
        }
      } : attr.onBlur,
      value: validationProps && (0, _values["default"])(validationProps) ? (0, _get["default"])((0, _values["default"])(validationProps), attr.name) : attr.value,
      invalid: isInvalid,
      className: (0, _utils.gatherClasses)(attr)
    })), !disableInputFeedback && validationProps && /*#__PURE__*/_react["default"].createElement(_inputFeedback["default"], {
      show: isInvalid,
      message: (0, _get["default"])(validationProps.errors, attr.name)
    }));
  });
  (0, _defineProperty2["default"])(this, "renderToggleInput", function (props) {
    var name = props.name,
        className = props.className,
        label = props.label,
        disableInputFeedback = props.disableInputFeedback,
        validationProps = props.validationProps,
        isInvalid = props.isInvalid,
        disabled = props.disabled;
    var isActive = validationProps && (0, _values["default"])(validationProps) ? (0, _get["default"])((0, _values["default"])(validationProps), name) : props.value;
    var onChange = validationProps && (0, _utils.isFunction)(validationProps.handleChange) ? validationProps.handleChange : props.onChange;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_toggleButton["default"], {
      dataTestId: props.dataTestId,
      className: className,
      disabled: disabled,
      label: label,
      isActive: isActive,
      isInvalid: isInvalid,
      name: name,
      onClick: function onClick(fieldName, currentStatus) {
        if (validationProps) {
          if (validationProps && (0, _utils.isFunction)(validationProps.setFieldTouched)) {
            validationProps.setFieldTouched(fieldName, true);
          }

          if (validationProps && (0, _utils.isFunction)(validationProps.setFieldValue)) {
            validationProps.setFieldValue(fieldName, currentStatus);
          }
        }

        if ((0, _utils.isFunction)(onChange)) {
          onChange.call(null, fieldName, currentStatus);
        }
      }
    }), !disableInputFeedback && validationProps && /*#__PURE__*/_react["default"].createElement(_inputFeedback["default"], {
      show: isInvalid,
      message: (0, _get["default"])(validationProps.errors, name)
    }));
  });
  (0, _defineProperty2["default"])(this, "renderInputButton", function (props) {
    var block = _this.blockProp;
    var classes = {
      button: (0, _utils.gatherClasses)(props, "oui-btn oui-btn-outline-primary", block ? "oui-btn-block" : ""),
      reset: (0, _utils.gatherClasses)(props, "oui-btn oui-btn-outline-primary", block ? "oui-btn-block" : ""),
      submit: (0, _utils.gatherClasses)(props, "oui-btn oui-btn-primary", block ? "oui-btn-block" : "")
    };
    return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
      "data-testid": props.dataTestId || "orion-input-button"
    }, props, {
      className: classes[props.type],
      value: props.label || props.type
    }));
  });
  (0, _defineProperty2["default"])(this, "renderInputSearch", function (props) {
    var showClearIcon = props.showClearIcon,
        clearTooltipText = props.clearTooltipText,
        onSearch = props.onSearch,
        onClear = props.onClear,
        clickable = props.clickable,
        dataTestId = props.dataTestId,
        attr = (0, _objectWithoutProperties2["default"])(props, _excluded3);

    function onKeyDown(e) {
      if (e.which === 13 || e.keyCode === 13) {
        if ((0, _utils.isFunction)(onSearch)) {
          onSearch(e.target.value);
        }
      } else if (e.which === 27 || e.keyCode === 27) {
        e.target.value = "";

        if ((0, _utils.isFunction)(onClear)) {
          onClear(e);
        }
      }

      if ((0, _utils.isFunction)(attr.onKeyDown)) {
        attr.onKeyDown(e);
      }
    }

    function onClearIconClick(e) {
      var el = e.target.parentElement.parentElement.querySelector(".oui-search-input-textbox");

      if (el && el instanceof HTMLElement) {
        el.value = "";
      }

      onClear(e);
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": dataTestId || "orion-search-input",
      className: "oui-search-input-container"
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      src: _icons.Search,
      className: "oui-search-input-icon"
    }), /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, attr, {
      type: "text",
      className: (0, _utils.gatherClasses)(attr, "oui-search-input-textbox", showClearIcon ? "oui-input-search-enabled" : null, clickable ? "oui-input-clickable" : null),
      onKeyDown: onKeyDown
    })), showClearIcon ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "oui-search-input-clear",
      onClick: onClearIconClick,
      "aria-hidden": "true"
    }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      text: clearTooltipText || "",
      showToolTip: !!(0, _utils.isString)(clearTooltipText),
      placement: "bottom"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oui-clear-icon"
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      src: _icons.MenuClose,
      width: "8px",
      height: "8px"
    })))) : null);
  });
  (0, _defineProperty2["default"])(this, "renderCustomInput", function (props) {
    var isInvalid = props.isInvalid,
        options = props.options,
        validationProps = props.validationProps,
        disableInputFeedback = props.disableInputFeedback,
        attr = (0, _objectWithoutProperties2["default"])(props, _excluded4);
    var checkedProp = {};

    if (validationProps) {
      if (attr.type.toLowerCase() === "radio") {
        checkedProp.checked = (0, _get["default"])((0, _values["default"])(validationProps), attr.name) === attr.value;
      } else if (attr.type.toLowerCase() === "checkbox") {
        var checkboxValues = (0, _get["default"])((0, _values["default"])(validationProps), attr.name);

        if ((0, _isArray["default"])(checkboxValues)) {
          checkedProp.checked = (0, _includes["default"])(checkboxValues).call(checkboxValues, attr.value);
        } else {
          checkedProp.checked = checkboxValues === attr.value || checkboxValues === true;
        }
      }
    }

    return /*#__PURE__*/_react["default"].createElement(_CustomInput["default"], (0, _extends2["default"])({
      "data-testid": props.dataTestId || "orion-".concat(attr.type, "-input")
    }, checkedProp, attr, {
      onChange: attr.onChange ? attr.onChange : validationProps && (0, _utils.isFunction)(validationProps.handleChange) ? validationProps.handleChange : function () {},
      onBlur: attr.onBlur ? attr.onBlur : validationProps && (0, _utils.isFunction)(validationProps.handleBlur) ? validationProps.handleBlur : function () {},
      value: attr.value ? attr.value : validationProps && (0, _values["default"])(validationProps) ? (0, _get["default"])((0, _values["default"])(validationProps), attr.name) : "",
      invalid: isInvalid,
      className: (0, _utils.gatherClasses)(props, props.type === "file" ? "oui-truncate" : null)
    }), props.type === "select" && options && options.length > 0 ? (0, _map["default"])(options).call(options, function (option, index) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: index,
        value: option.value || option.label
      }, option.label);
    }) : null);
  });
});
exports["default"] = InputUtils;